import { render, staticRenderFns } from "./JS.vue?vue&type=template&id=40e9a843&scoped=true&"
import script from "./JS.vue?vue&type=script&lang=js&"
export * from "./JS.vue?vue&type=script&lang=js&"
import style0 from "./JS.vue?vue&type=style&index=0&id=40e9a843&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e9a843",
  null
  
)

export default component.exports